import { i18n } from '../main'

export const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

export const openExternalLink = () => {
  const anchors = document.getElementsByTagName('a')
  const anchorsKeys = Object.keys(anchors)
  for (let key in anchorsKeys) {
    if (anchors[key].getAttribute('href').includes('http')) {
      anchors[key].setAttribute('target', '_blank')
      anchors[key].setAttribute('rel', 'noreferrer noopener')
    }
  }
}

export const setResponsiveHeader = isResponsive => {
  var viewportTag = document.getElementsByTagName('meta').viewport
  viewportTag.content = isResponsive ? 'width=device-width,initial-scale=1.0' : 'width=1000'
}

export const getTranslatedOptions = options => options && options.map(item => ({ ...item, label: i18n.t(item.label) }))
